import { ISwAppTransfersApi } from "../../interfaces-and-types";

type TTransfersUrls = {
  [key in keyof ISwAppTransfersApi]: string;
};

const rootTransfersUrl = "/transfers";

export const transfersUrls: TTransfersUrls = {
  createBatchBankTransfer: `${rootTransfersUrl}/bank`,
  // createBatchGatewayTransfer: `${rootTransfersUrl}/gateway`,

  getBatchList: `${rootTransfersUrl}/batch`,
  getBatchById: `${rootTransfersUrl}/batch/id`,
  getBatchByRef: `${rootTransfersUrl}/batch/reference/batch_ref`,
  requeueFailedInBatchByRef: `${rootTransfersUrl}/batch/requeue-failed/batch_ref`,
  approveBatchTransferByRef: `${rootTransfersUrl}/batch/approve-transfers/batch_ref`,

  getSingleTransfersList: `${rootTransfersUrl}/singles`,
  getSingleTransfersListByBatchRef: `${rootTransfersUrl}/batch/batch_ref/transfers`,
  getSingleTransferById: `${rootTransfersUrl}/single/id`,
  getSingleTransferByRef: `${rootTransfersUrl}/single/reference/transfer_ref`,
  generateTransferReceiptById: `${rootTransfersUrl}/single/id/receipt`,

  getTransferFee: `${rootTransfersUrl}/fee`,
  getTransferRate: `${rootTransfersUrl}/rate`,
};
